import Bugsnag from "@bugsnag/js";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import Tag from "@Components/atoms/Tag";
import { Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import "./style.scss";

interface Props {
  tile: Tile;
}

const ChoicesPacks: FunctionComponent<Props> = ({ tile }) => {
  const intl = useIntl();
  const locale = intl.locale;

  return (
    <div className="ChoicesPacks">
      <div className="ChoicesPacks-title">{tile.action?.title}</div>
      <div className="ChoicesPacks-packs-wrapper">
        <div className="ChoicesPacks-packs">
          {tile.action?.entries
            ? tile.action?.entries.map((entry) => {
                const text = entry.text.split(" ");

                if (!entry.navigationLink) {
                  Bugsnag.notify(
                    new Error(`navigationLink for tile ${tile.slug} not found in ChoicesPacks`)
                  );
                  return;
                }

                return (
                  <a
                    className="ChoicesPacks-pack"
                    href={getLink(entry.navigationLink, locale)}
                    key={entry.text}
                  >
                    {entry.discount && (
                      <Tag backgroundColor="#2c9358" isRotated={true} size="m">
                        {entry.discount}
                      </Tag>
                    )}
                    <div className="ChoicesPacks-pack-text">
                      {text[0]}
                      <span>{text[1]}</span>
                    </div>
                    <div className="ChoicesPacks-pack-hovered-text">{entry.fullPrice}</div>
                    <div className="ChoicesPacks-pack-price">{entry.price}</div>
                  </a>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default ChoicesPacks;
